import { utils, writeFile } from 'xlsx'
import { UnsettledSecuritiesPendingTitles } from '@/types/UnsettledSecurities'
import { getDateFromId } from '@/utils/date'
 
export const usePendingTitlesSpreadsheets = () => {
    
    const getTableRows = (positionData: UnsettledSecuritiesPendingTitles[])  =>
        positionData.map((row) => {
            const obj = {} as Record<string, any>

            obj['Origem'] = row.DD_ORIGEM_POSICAO
            obj['Revenda'] = row.NM_REVENDA
            obj['Empresa'] = row.ABREVIATURA_EMPRESA
            obj['Cod. Cliente'] = row.NK_CLIENTE
            obj['Nome Fantasia'] = row.DS_NOME_FANTASIA
            obj['UF'] = row.DD_ESTADO
            obj['Num. Doc'] = row.DD_NUMERO_DOCUMENTO
            obj['Data Emissão'] = getDateFromId(row.SK_EMISSAO)
            obj['Data Vencimento'] = getDateFromId(Number(row.SK_VENCIMENTO))
            obj['Data Vencimento Real'] = getDateFromId(Number(row.SK_VENCIMENTO_REAL))
            obj['Data Baixa'] = row.SK_BAIXA ? getDateFromId(Number(row.SK_BAIXA)) : ''
            obj['Dias Juros'] = Number(row.DD_DIAS_JUROS)
            obj['Valor N.F.'] = Number(row.VL_NF)
            obj['Valor a Vencer'] = Number(row.VL_A_VENCER)
            obj['Valor Vencido'] = Number(row.VL_VENCIDO)
            obj['Valor Vencido + A Vencer'] = Number(row.VL_VENCIDO_E_A_VENCER)
            obj['Juros Pelo Prazo'] = Number(row.VL_JUROS_PELO_PRAZO)
            obj['Valor Multa'] = Number(row.VL_MULTA)
            obj['Valor Total com Juros'] = Number(row.VL_TOTAL_COM_JUROS)
            obj['Num. Bordero'] = row.DD_NUMERO_BORDERO
            obj['Portador'] = row.DD_PORTADOR
            obj['Data Bordero'] = row.SK_TEMPO_BORDERO ? getDateFromId(Number(row.SK_TEMPO_BORDERO)) : ''
            obj['Tipo N.F'] = row.DD_TIPO
            obj['Historico'] = row.DS_HISTORICO
            obj['Cod. Produto'] = row.NK_PRODUTO
            obj['Produto'] = row.DS_PRODUTO
            obj['Tipo Produto'] = row.DD_TIPO_PRODUTO
            obj['U.M.'] = row.DD_UNIDADE_MEDIDA
            obj['NCM'] = row.DD_NCM
            obj['Cod. Condição Pag.'] = row.DD_CODIGO_CONDICAO_PAGAMENTO
            obj['Condição Pagamento'] = row.DD_NM_CONDICAO_PAGAMENTO
            obj['Intercompany?'] = row.DD_INTERCOMPANY
            obj['CNPJ'] = row.DD_CNPJ
            obj['Parcela'] = row.DD_PARCELA
            obj['Distribuidor'] = row.NM_PROPRIETARIO
            obj['Prefixo'] = row.DD_PREFIXO
            obj['Moeda'] = row.DD_MOEDA

            return obj
        })

    const onDownload = (positionData: UnsettledSecuritiesPendingTitles[]) => {

        const workbook = utils.book_new()

        const rows = getTableRows(positionData) 
        const colluns = Object.keys(rows[0]).length;

        const formatDate = 'dd/mm/yyyy'
        const formatMoneyAccounting = '_-* #,##0.00_-;-* #,##0.00_-;_-* "-"??_-;_-@_-' 

        const worksheet = utils.aoa_to_sheet([[]]);
        
        worksheet['L1'] =  { t: 's', v: 'Totais: ' }
        worksheet['M1'] =  { t: 'n', f: `SUBTOTAL(9, M3:M${rows.length + 3})`, z: formatMoneyAccounting }
        worksheet['N1'] =  { t: 'n', f: `SUBTOTAL(9, N3:N${rows.length + 3})`, z: formatMoneyAccounting }
        worksheet['O1'] =  { t: 'n', f: `SUBTOTAL(9, O3:O${rows.length + 3})`, z: formatMoneyAccounting }
        worksheet['P1'] =  { t: 'n', f: `SUBTOTAL(9, P3:P${rows.length + 3})`, z: formatMoneyAccounting }
        worksheet['Q1'] =  { t: 'n', f: `SUBTOTAL(9, Q3:Q${rows.length + 3})`, z: formatMoneyAccounting }
        worksheet['R1'] =  { t: 'n', f: `SUBTOTAL(9, R3:R${rows.length + 3})`, z: formatMoneyAccounting }
        worksheet['S1'] =  { t: 'n', f: `SUBTOTAL(9, S3:S${rows.length + 3})`, z: formatMoneyAccounting }
        
        utils.sheet_add_json(worksheet, rows, {
            origin: { r: 1, c: 0 } 
        });

        for (let i = 2; i <= rows.length + 2; i++) { 
            
            worksheet[`H${i}`].z = formatDate
            worksheet[`I${i}`].z = formatDate
            worksheet[`J${i}`].z = formatDate
            worksheet[`K${i}`].z = formatDate
            worksheet[`V${i}`].z = formatDate
            
            worksheet[`M${i}`].z = formatMoneyAccounting
            worksheet[`N${i}`].z = formatMoneyAccounting
            worksheet[`O${i}`].z = formatMoneyAccounting
            worksheet[`P${i}`].z = formatMoneyAccounting
            worksheet[`Q${i}`].z = formatMoneyAccounting
            worksheet[`R${i}`].z = formatMoneyAccounting 
            worksheet[`S${i}`].z = formatMoneyAccounting 
        }

        worksheet["!cols"] =  Array(colluns).fill({ wch: 20 });


        utils.book_append_sheet(workbook, worksheet, `Pendencias`) 
        

        const currentDate = new Date();
        const day = currentDate.getDate().toString().padStart(2, '0');
        const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
        const year = currentDate.getFullYear().toString();
        const currentDateFormated =  day + month + year;

        writeFile(workbook, `Pendencias_${currentDateFormated}.xlsx`, {
            compression: true,
            cellStyles: true
        })
    }

    return {
        onDownload,
    }
}
